import createStore from "astrid-helpers/src/createStore";
import { getPages } from "./pages";
import { onSearch } from "./search";
export const [getSearchResults, setSearchResults, useSearchResults] = createStore([]);
onSearch(search => {
  const pages = getPages();
  if (pages.length > 0 && search) {
    const results = [];
    const regex = new RegExp(search, "gi");
    for (const {
      page,
      text,
      items
    } of pages) {
      if (text.match(regex)) {
        for (const [, item] of items.entries()) {
          if (item.text.match(regex)) {
            results.push({
              page,
              ...item
            });
          }
        }
      }
    }
    setSearchResults(results);
  } else {
    setSearchResults([]);
  }
});
//# sourceMappingURL=searchResults.js.map